// extracted by mini-css-extract-plugin
var _1 = "FileMultiValue-moduleFileMultiValue__T4C7d";
var _2 = "FileMultiValue-moduleicon__ufimj FileIconPreview-moduleicon__wDz2Z FileIconPlaceholder-modulefileIconPlaceholder__ZGAvo FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
var _3 = "FileMultiValue-moduletext__ywBLO TableCellText-moduleTableCellText__b5epO";
export { _1 as "FileMultiValue", _2 as "icon", _3 as "text" }
